import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function uid(n = 10): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let s = ''
  for (let i = 0; i < n; i++) s += chars[Math.floor(Math.random() * chars.length)]
  return s
}

export function relativeTime(ts: number): string {
  const diff = Date.now() - ts
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'now'
  if (min < 60) return `${min}m`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h`
  const day = Math.floor(hr / 24)
  if (day < 7) return `${day}d`
  return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

/**
 * Run `load` now and every `ms` — but only while the tab is visible (a hidden tab doesn't burn
 * market-data calls); it reloads the moment the tab comes back. Returns the cleanup.
 */
export function pollWhileVisible(load: () => void, ms: number): () => void {
  const visible = () => typeof document === 'undefined' || document.visibilityState === 'visible'
  if (visible()) load()
  const t = setInterval(() => {
    if (visible()) load()
  }, ms)
  const onVis = () => {
    if (visible()) load()
  }
  document.addEventListener('visibilitychange', onVis)
  return () => {
    clearInterval(t)
    document.removeEventListener('visibilitychange', onVis)
  }
}
